import { render } from "./admin-header.vue?vue&type=template&id=04407c42"
const script = {}

import "./admin-header.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script